import BgImg from '~/assets/holiday/memorial-day/menu/bg.png';
import TopWidget from '~/assets/holiday/memorial-day/menu/topWidget.png';
import { BaseMenu } from './BaseMenu';

export const MemorialDayMenu = () => (
  <BaseMenu
    config={{
      containerBgClass: 'bg-[#0F2A63] bg-contain bg-bottom bg-no-repeat pt-4',
      containerStyle: { 'background-image': `url(${BgImg})` },
      collapseButtonZIndex: true,
      activeColor: '#7717DD',
      tooltipBgColor: '#7717DD',
      linkTooltipBgColor: '#7717DD',
      decoration: (
        <div class="absolute left-0 top-0 w-full">
          <img class="w-full" src={TopWidget} alt="top left widget" />
        </div>
      ),
    }}
  />
);
